












































import {Component, Vue} from 'vue-property-decorator'

import {Bracket} from '@/icons'

@Component({
  components: {
    Bracket
  }
})
export default class BeforeAnalysis extends Vue {
}
